/* Selva Tierra tattoo cultures map: world map with a pin per tradition; tapping a pin fills the card. */
(function () {
  var D3_URL = 'https://cdnjs.cloudflare.com/ajax/libs/d3/7.9.0/d3.min.js';
  var TOPO_URL = 'https://cdn.jsdelivr.net/npm/topojson-client@3.1.0/dist/topojson-client.min.js';
  var WORLD_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded || (src === D3_URL && window.d3) || (src === TOPO_URL && window.topojson)) return resolve();
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { s.dataset.loaded = '1'; resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHtml(t) {
    var html = '<p class="cultures__card-eyebrow">' + escapeHtml(t.regionLabel) + (t.era ? ' · ' + escapeHtml(t.era) : '') + '</p>' +
      '<h3 class="cultures__card-title">' + escapeHtml(t.title) + '</h3>' +
      (t.place ? '<p class="cultures__card-place">' + escapeHtml(t.place) + '</p>' : '');
    [['Technique', t.technique], ['Meaning', t.meaning], ['On the body', t.placement]].forEach(function (row) {
      if (row[1]) html += '<h4>' + row[0] + '</h4><p>' + escapeHtml(row[1]) + '</p>';
    });
    if (t.link) html += '<a class="cultures__card-link" href="' + escapeHtml(t.link) + '" target="_blank" rel="noopener">Learn more &rarr;</a>';
    return html;
  }

  function init(root) {
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-cultures-data]').textContent); } catch (e) { return; }
    data = data.filter(function (t) { return !isNaN(parseFloat(t.lat)) && !isNaN(parseFloat(t.lng)); })
      .map(function (t) { t.lat = parseFloat(t.lat); t.lng = parseFloat(t.lng); return t; });

    var stage = root.querySelector('.cultures__stage');
    var card = root.querySelector('[data-cultures-card]');

    loadScript(D3_URL)
      .then(function () { return loadScript(TOPO_URL); })
      .then(function () { return fetch(WORLD_URL); })
      .then(function (r) { return r.json(); })
      .then(function (world) { draw(world); })
      .catch(function () { stage.querySelector('.cultures__loading').textContent = 'The map could not load. The list below has every tradition.'; });

    function draw(world) {
      var d3 = window.d3;
      var W = 960, H = 500;
      var svg = d3.select(stage.querySelector('svg')).attr('viewBox', '0 0 ' + W + ' ' + H);
      var land = window.topojson.feature(world, world.objects.countries);
      var projection = d3.geoEqualEarth().fitExtent([[8, 8], [W - 8, H - 8]], { type: 'Sphere' });
      var path = d3.geoPath(projection);
      var g = svg.append('g');

      g.append('path').datum({ type: 'Sphere' }).attr('class', 'cultures__sea').attr('d', path);
      g.append('path').datum(d3.geoGraticule10()).attr('class', 'cultures__grid').attr('d', path);
      g.append('g').selectAll('path').data(land.features).join('path').attr('class', 'cultures__land').attr('d', path);

      var pins = g.append('g').selectAll('g').data(data).join('g')
        .attr('class', function (t) { return 'cultures__pin cultures__pin--' + t.region; })
        .attr('transform', function (t) { var p = projection([t.lng, t.lat]); return 'translate(' + p[0] + ',' + p[1] + ')'; })
        .attr('tabindex', 0)
        .attr('role', 'button')
        .attr('aria-label', function (t) { return t.title + ', ' + t.place; });
      pins.append('circle').attr('class', 'cultures__pin-halo').attr('r', 11);
      pins.append('circle').attr('class', 'cultures__pin-dot').attr('r', 6);

      var active = null;
      function select(t, el) {
        if (active) active.classList.remove('is-active');
        active = el; el.classList.add('is-active');
        el.parentNode.appendChild(el);
        card.innerHTML = cardHtml(t);
        card.classList.remove('is-fresh'); void card.offsetWidth; card.classList.add('is-fresh');
        if (window.matchMedia('(max-width: 989px)').matches) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      pins.on('click', function (ev, t) { select(t, this); })
        .on('keydown', function (ev, t) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); select(t, this); } });

      var zoom = d3.zoom().scaleExtent([1, 8]).translateExtent([[0, 0], [W, H]]).on('zoom', function (ev) {
        g.attr('transform', ev.transform);
        pins.attr('transform', function (t) { var p = projection([t.lng, t.lat]); return 'translate(' + p[0] + ',' + p[1] + ') scale(' + (1 / Math.sqrt(ev.transform.k)) + ')'; });
        g.selectAll('.cultures__land').attr('stroke-width', 0.6 / ev.transform.k);
      });
      svg.call(zoom).on('wheel.zoom', null);
      root.querySelector('[data-zoom="in"]').onclick = function () { svg.transition().duration(300).call(zoom.scaleBy, 1.6); };
      root.querySelector('[data-zoom="out"]').onclick = function () { svg.transition().duration(300).call(zoom.scaleBy, 0.625); };
      root.querySelector('[data-zoom="reset"]').onclick = function () { svg.transition().duration(400).call(zoom.transform, d3.zoomIdentity); };

      stage.classList.add('is-ready');
    }
  }

  function boot() { document.querySelectorAll('[data-cultures-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
